import { Typography, Box, styled, Fade, Paper, Button, Grid } from '@mui/material';
import { FC } from 'react';
import ErrorIcon from '@acorn-portal/shared/src/assets/shared/icons/base/broken-down-car.svg?react';
import { getCustomerPortalLink } from '@acorn-portal/shared/src/utils/get-customer-portal-link';

const ImageWrapper = styled('div')(({ theme }) => ({
	'& svg': {
		height: 'auto',
		width: '15em',
		[theme.breakpoints.down('md')]: {
			maxWidth: '220px',
		},
	},
}));

const ErrorPage: FC = () => {
	const companyPortalLink = getCustomerPortalLink();
	return (
		<Fade in>
			<Box
				sx={(theme) => ({
					[theme.breakpoints.up('md')]: {
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: '5vh',
					},

					p: 3,
				})}
			>
				<Paper
					sx={{
						p: 4,
						display: 'flex',
						flex: 1,
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Typography
						variant='h4'
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '2rem',
							},
						})}
						color='primary'
						gutterBottom
						textAlign='center'
					>
						Payment Option Expired
					</Typography>
					<ImageWrapper>
						<ErrorIcon />
					</ImageWrapper>
					<Typography
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								px: 2,
							},

							pt: 4,
							px: 8,
							textAlign: 'center',
						})}
						gutterBottom
					>
						This payment option has expired, please get in touch with customer services for a new link.
						<p />
						To bring your account up to date with us, you can also log into our portal where you can make payment.
					</Typography>
					{companyPortalLink && (
						<Grid container spacing={2}>
							<Grid size={{ xs: 12 }}>
								<Box sx={{ display: 'flex', justifyContent: 'center' }}>
									<Button
										href={companyPortalLink}
										variant='contained'
										color='primary'
										sx={{ mt: 2, width: { xs: '100%', md: '50%' }, px: 10 }}
									>
										Portal
									</Button>
								</Box>
							</Grid>
						</Grid>
					)}
				</Paper>
			</Box>
		</Fade>
	);
};

export default ErrorPage;
